import React, {useEffect, useRef, useState} from "react";
import useAlert from "../../../CustomHooks/useAlert";
import {useParams} from "react-router-dom";
import RichTextEditor from "../../../Components/RichTextEditor";
import GrapesJSEditor from "../Pages/GrapesJSEditor";
import ReactQuill from "react-quill";
import axios from "axios";
import {fetchContentEditors} from "../../../redux/actions/PagesDataActions";
import {useDispatch, useSelector} from "react-redux";
import TableComponent from "../../../Components/TableComponentFiles/TableComponent";
import AceEditor from "react-ace";

const types = [
    {name: "Quill Editor", value: "quill"},
    {name: "Rich Text Editor (TinyMce)", value: "tinymce"},
    {name: "Grapes Js Editor", value: "grapes"},
]
const ContentEditors = () => {
    const {id} = useParams()
    const dispatch = useDispatch()
    const {contentEditors, success} = useSelector((state) => state.contentEditorsReducer);
    useEffect(() => {
        dispatch(fetchContentEditors())
    }, []);
    const [formData, setFormData] = useState({
        name: "",
        type: "",
        html: "",
        css: ""
    })
    useEffect(() => {
        if (id && success) {
            const contentEditor = contentEditors.find(x => x.id === Number(id))
            setFormData(contentEditor)
        }
    }, [id, success]);
    const editorRef = useRef();
    const [showAlert, AlertComponent] = useAlert();
    const submit = async (e) => {
        e.preventDefault()
        if (id) {
            try {
                const response = await axios.post('/admin/content/update/content-editor/' + id, formData);
                showAlert("success", "Content Editor Updated")
                dispatch(fetchContentEditors())
            } catch (error) {
                showAlert("error", error.message)
            }
        } else {
            try {
                const response = await axios.post('/admin/content/add/content-editor', formData);
                showAlert("success", "Content Editor Added")
                dispatch(fetchContentEditors())
            } catch (error) {
                showAlert("error", error.message)
            }
        }
    }
    const handleChange = (value, field) => {
        setFormData(prevState => ({...prevState, [field]: value}));
    };

    return (
        <div className="flex flex-col bg-gray-100 min-h-[84vh] gap-4">
            {AlertComponent}
            <form onSubmit={submit} className="flex flex-col rounded-lg mt-4 mx-2 p-4 bg-white gap-3">
                    <span
                        className="text-lg font-public-sans font-bold">{id ? "Edit" : "Add"} Rich Content Editor</span>
                <hr/>
                <div className="w-full">
                    <label htmlFor="order">Title</label>
                    <input type="text" id="order" value={formData.name} required={true}
                           onChange={(e) => setFormData((prevState) => ({...prevState, name: e.target.value}))}
                           className="py-2 px-3 mt-0.5 rounded-md w-full border border-gray-500"/>
                </div>
                <div className="w-full">
                    <label htmlFor="type">Type</label>
                    <select className="py-2 px-3 mt-1 rounded-md w-full border border-gray-500"
                            id="type" value={formData.type} required={true}
                            onChange={(e) => setFormData({...formData, type: e.target.value})}>
                        <option value={""} disabled selected>Select Type</option>
                        {types.map(type => (
                            <option key={type.value} value={type.value}>{type.name}</option>
                        ))}
                    </select>
                </div>
                {formData.type === "grapes" ?
                    <GrapesJSEditor ref={editorRef} customHtml={formData.html}
                                    customCss={formData.css} setFormData={setFormData}
                                    formData={formData}/> : formData.type === "tinymce" ?
                        <div className="w-full">
                            <RichTextEditor value={formData.html}
                                            onChange={(value) => setFormData({...formData, html: value})}/>
                        </div> : formData.type === "quill" ? <div className="w-full">
                            <ReactQuill value={formData.html}
                                        onChange={(value) => setFormData({...formData, html: value})}/>
                        </div> : null}
                <div className="w-full">
                    <div>HTML</div>
                    <AceEditor
                        mode="html"
                        theme="github_dark"
                        value={formData.html}
                        onChange={(value) => handleChange(value, 'html')}
                        name="htmlEditor"
                        editorProps={{$blockScrolling: true}}
                        fontSize={14}
                        showPrintMargin={true}
                        showGutter={true}
                        highlightActiveLine={true}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }}
                        style={{width: '100%', height: '150px'}}
                    />
                    <div className="mt-4">CSS</div>
                    <AceEditor
                        mode="css"
                        theme="github_dark"
                        value={formData.css}
                        onChange={(value) => handleChange(value, 'css')}
                        name="cssEditor"
                        editorProps={{$blockScrolling: true}}
                        fontSize={14}
                        showPrintMargin={true}
                        showGutter={true}
                        highlightActiveLine={true}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }}
                        style={{width: '100%', height: '150px'}}
                    />
                </div>
                <button
                    className="w-full hover:bg-fuchsia-800 hover:shadow-2xl mt-5 px-7 py-3 font-bold text-white bg-blue-700 rounded cursor-pointer transition-all shadow-md"
                    type="submit">{(id ? "Update" : "Add")} Rich Content Editor
                </button>
            </form>
            {success && contentEditors.length > 0 && !id && <div className="rounded-lg bg-white mx-2 mb-4">
                <TableComponent TableData={contentEditors.map(({id, name, type, updated_at}) => ({
                    id,
                    name,
                    type,
                    updated_at
                }))} tableName="Content Editors" showAlert={showAlert}/>
            </div>}
        </div>
    )
}
export default ContentEditors